<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="maintoc">
<p class="ct">Contents</p>
<p class="tocfm"><a class="calibre3" href="#/OEBPS/pppmaddog004#ded">Dedication</a></p>
<p class="tocfm"><a class="calibre3" href="#/OEBPS/pppmaddog005#epigraph">Epigraph</a></p>
<p class="tocfm"><a class="calibre3" href="#/OEBPS/pppmaddog007#ch01">Mad Dog &amp; Englishman</a></p>
<p class="tocfm"><a class="calibre3" href="#/OEBPS/pppmaddog009#acknow">Afterword/Acknowledgment</a></p>
<p class="tocfm"><a class="calibre3" href="#/OEBPS/pppmaddog010#moreauth">More from this Author</a></p>
<p class="tocfm"><a class="calibre3" href="#/OEBPS/pppmaddog011#contactus">Contact Us</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-maddog006.vue?5189160a